if(window.location.origin === 'http://localhost:8080')
{
    var apiDomain = 'http://localhost:9999';
}
else
{
   var apiDomain = window.location.origin;
}


export default {
    apiUrl: {
        system: {
            //메뉴 조회하는 api url
            menuList: apiDomain + '/system/member/selectUsrMenuList.json',

             
            //*****회원 관리******
            //회원조회하는 api url
            getUserList: apiDomain + '/system/member/selectInfoList.json',
            //userId 중복조회 api url
            userIdCheck: apiDomain + '/system/member/userIdCheck.json',
            //user 저장 api url
            insertInfo: apiDomain + '/system/member/preinsertInfo.json',
            //user 상세조회 api url
            selectInfo: apiDomain + '/system/member/getselect.json',
            //user 수정 api url
            updateInfo: apiDomain + '/system/member/updateInfo.json',
            //user 삭제 api url
            deleteInfo: apiDomain + '/system/member/deleteInfo.json',


            //*********어플 회원 관리 ******* */
            getAppUserList: apiDomain + '/system/appMember/selectInfoList.json',

            appSelectInfo: apiDomain + '/system/appMember/getselect.json',

            //user 삭제 api url
            appDeleteInfo: apiDomain + '/system/member/appDeleteInfo.json',

            appUpdateInfo: apiDomain + '/system/member/appUpdateInfo.json',

            //앱 회원 비밀번호 초기화
            appPassInfo: apiDomain + '/system/member/appUpdateInfo.json',
            appMemberInfoPwdInit: apiDomain + '/system/member/memberInfoPwdInit.json',


            //*****프로그램 관리******
            //프로그램 조회하는 api url
            getProgList: apiDomain + '/system/menu/progInfoList.json',
            //프로그램 저장 api url
            proginsertInfo: apiDomain + '/system/menu/insertProgInfo.json',
            //프로그램 상세조회 api url
            progselectInfo: apiDomain + '/system/menu/getselect.json',
            //프로그램 수정 api url
            progupdateInfo: apiDomain + '/system/menu/updateProgInfo.json',
            //프로그램 삭제 api url
            progdeleteInfo: apiDomain + '/system/menu/deleteProgInfo.json',

            //*****권한 관리******
            getauthList: apiDomain + '/system/menu/authInfoList.json',
            authinsertInfo: apiDomain + '/system/menu/insertAuthInfo.json',

            authupdateInfo: apiDomain + '/system/menu/updateAuthInfo.json',
            authdeleteInfo: apiDomain + '/system/menu/deleteAuthInfo.json',

            authselectInfo: apiDomain + '/system/menu/insertAuthInfo.json',


            //*****메뉴 관리******
            getauthMenuList: apiDomain + '/system/menu/menuAuthList.json',
            insertauthMenuList: apiDomain + '/system/menu/menuAuthEdit.json',

        },
        coalitionCompany: {
            coalitionCompanyList: apiDomain + '/coalitionCompany/selectInfoList.json',
            insertInfo: apiDomain + '/coalitionCompany/insertInfo.json',
            updateInfo: apiDomain + '/coalitionCompany/updateInfo.json',
            deleteInfo: apiDomain + '/coalitionCompany/deleteInfo.json',
        },
        money: {
            moneyManagementList: apiDomain + '/money/moneymanagement/selectInfoList.json',
            lastDate: apiDomain + '/money/moneymanagement/lastDate.json',
            //money 저장 api url
            insertInfo: apiDomain + '/board/budget/insertInfo.json',
            //money 상세조회 api url
            getselectInfo: apiDomain + '/money/moneymanagement/getselect.json',
            //money 수정 api url
            updateInfo: apiDomain + '/board/budget/updateInfo.json',
            //money 삭제 api url
            deleteInfo: apiDomain + '/board/budget/deleteInfo.json',
            //money 엑셀 다운로드 api url
            MngExcel: apiDomain + '/board/budget/MngExcel.do',

        },
        innerMoney: {
            moneyManagementList: apiDomain + '/money/moneymanagement/innerSelectInfoList.json',
            
            lastDate: apiDomain + '/money/moneymanagement/innerLastDate.json',
            //money 저장 api url
            insertInfo: apiDomain + '/board/innerBudget/insertInfo.json',
            //money 상세조회 api url
            getselectInfo: apiDomain + '/money/moneymanagement/innerGetselect.json',
            //money 수정 api url
            updateInfo: apiDomain + '/board/innerBudget/updateInfo.json',
            //money 삭제 api url
            deleteInfo: apiDomain + '/board/innerBudget/deleteInfo.json',
            //money 엑셀 다운로드 api url
            MngExcel: apiDomain + '/board/budget/InnerMngExcel.do',

        },
        manager: {
            managerManagementList: apiDomain + '/medicine/managerManagement/selectInfoList.json',
            hospitalInfoList: apiDomain + '/medicine/managerManagement/hospitalInfoList.json',
            pharmacistInfoList: apiDomain + '/medicine/managerManagement/pharmacistInfoList.json',
            // 저장 api url
            insertInfo: apiDomain + '/medicine/managerManagement/insertInfo.json',

            deleteInfo: apiDomain + '/medicine/managerManagement/deleteInfo.json',

            hospitalInsertInfo: apiDomain + '/medicine/managerManagement/hospitalInsertInfo.json',
            pharmacistInsertInfo: apiDomain + '/medicine/managerManagement/pharmacistInsertInfo.json',


            hospitalDeleteInfo: apiDomain + '/medicine/managerManagement/hospitalDeleteInfo.json',
            pharmacistDeleteInfo: apiDomain + '/medicine/managerManagement/pharmacistDeleteInfo.json',


            updateInfo: apiDomain + '/medicine/managerManagement/updateInfo.json',

            hospitalUpdateInfo: apiDomain + '/medicine/managerManagement/hospitalUpdateInfo.json',
        },
        pharmacist: {
            pharmacistList: apiDomain + '/pharmacist/selectInfoList.json',
            closeBypharmacistList: apiDomain + '/pharmacist/closeSelectInfoList.json',
            insertInfo: apiDomain + '/pharmacist/insertInfo.json',
            updateInfo: apiDomain + '/pharmacist/updateInfo.json',
            deleteInfo: apiDomain + '/pharmacist/deleteInfo.json',
        },
        medicine: {
            // 저장 api url
            insertInfo: apiDomain + '/medicine/medicineManagement/insertInfo.json',
            medicineManagementList: apiDomain + '/medicine/medicineManagement/selectInfoList.json',
            getselect: apiDomain + '/medicine/medicineManagement/getselect.json',
            serverUpload: apiDomain + '/medicine/medicineManagement/serverUpload.json',
            medicineServerList: apiDomain + '/medicine/medicineManagement/serverInfoList.json',
            medicineServerInsertInfo: apiDomain + '/medicine/medicineManagement/serverInsertInfo.json',
            deleteInfo: apiDomain + '/medicine/medicineManagement/deleteInfo.json',
            updateInfo: apiDomain + '/medicine/medicineManagement/updateInfo.json',
            handInsertInfo: apiDomain + '/medicine/medicineManagement/handInsertInfo.json',


            apiToGetMoney: apiDomain + '/medicine/medicineManagement/apiToGetMoney.json',
            getImageApiSearch: apiDomain + '/medicine/medicineManagement/getImageApiSearch.json',
            getDetailInfoApiSearch: apiDomain + '/medicine/medicineManagement/getDetailInfoApiSearch.json',
            moneyUpdateInfo: apiDomain + '/medicine/medicineManagement/moneyUpdateInfo.json',
        },

        sales: {
            salesManagementList: apiDomain + '/medicine/salesManagement/selectInfoList.json',
            selectInfoCompanyList: apiDomain + '/medicine/salesManagement/selectInfoCompanyList.json',
            
            insertInfo: apiDomain + '/medicine/salesManagement/insertInfo.json',
            updateInfo: apiDomain + '/medicine/salesManagement/updateInfo.json',
            hospitalNameUpdateInfo: apiDomain + '/medicine/salesManagement/hospitalNameUpdateInfo.json',
            deleteInfo: apiDomain + '/medicine/salesManagement/deleteInfo.json',
        },
        calculate: {
            insertInfo: apiDomain + '/medicine/calculateManagement/insertInfo.json',
            insertCompanyInfo: apiDomain + '/medicine/calculateManagement/insertCompanyInfo.json',
            calculateManagementList: apiDomain + '/medicine/calculateManagement/selectInfoList.json',
            calculateCompanyList: apiDomain + '/medicine/calculateManagement/selectCompanyInfoList.json',
            getselect: apiDomain + '/medicine/calculateManagement/getselect.json',
            getselectCompany: apiDomain + '/medicine/calculateManagement/getselectCompany.json',
            updateInfo: apiDomain + '/medicine/calculateManagement/updateInfo.json',
            deleteInfo: apiDomain + '/medicine/calculateManagement/deleteInfo.json',
            excelDown: apiDomain + '/medicine/calculateManagement/excelDown.json'
        },
        edi: {
            ediList: apiDomain + '/edi/ediManagement/selectInfoList.json',
            ediSelect: apiDomain + '/edi/ediManagement/getselect.json',
            changePrint: apiDomain + '/edi/ediManagement/updateInfo.json',
            printgetselect: apiDomain + '/edi/ediManagement/printgetselect.json',
            deleteInfo: apiDomain + '/edi/ediManagement/deleteInfo.json',
        },

        notice: {
            noticeList: apiDomain + '/notice/selectInfoList.json',
            insertInfo: apiDomain + '/notice/insertInfo.json',
            getSelect: apiDomain + '/notice/getselect.json',
            updateInfo: apiDomain + '/notice/updateInfo.json',
            deleteInfo: apiDomain + '/notice/deleteInfo.json',
        },

        moveRequest: {
            moveRequestList: apiDomain + '/moveRequestMangement/selectInfoList.json',
            updateInfo: apiDomain + '/moveRequestMangement/updateInfo.json',
            MngExcel: apiDomain + '/moveRequestMangement/MngExcel.do',
            deleteInfo: apiDomain + '/moveRequestMangement/deleteInfo.json',
        },
        possibleDeal: {
            possibleDealList: apiDomain + '/possibleDeal/selectInfoList.json',
            updateInfo: apiDomain + '/possibleDeal/updateInfo.json',
            MngExcel: apiDomain + '/possibleDeal/MngExcel.do',
            openUpdateInfo: apiDomain + '/possibleDeal/openUpdateInfo.json',
            possibleDelete:apiDomain + '/possibleDeal/possibleDeleteInfo.json',
        },
        oneToOneInquiry: {
            oneToOneInquiryList: apiDomain + '/oneToOneInquiry/selectInfoList.json',
            getSelect: apiDomain + '/oneToOneInquiry/getselect.json',
            updateInfo: apiDomain + '/oneToOneInquiry/updateInfo.json',
            deleteInfo: apiDomain + '/oneToOneInquiry/deleteInfo.json',
        },
        statistics:{
            salesStatistics: apiDomain + '/statistics/salesStatistics/selectInfoList.json',
            ediCount: apiDomain + '/statistics/dashboardEDICount/selectInfoList.json',
            moveCount: apiDomain + '/statistics/dashboardMoveCount/selectInfoList.json',
            possibleDealCount: apiDomain + '/statistics/possibleDealCount/selectInfoList.json',
            ediByChart: apiDomain + '/statistics/ediByChart/selectInfoList.json',
            appUserByChart: apiDomain + '/statistics/appUserByChart/selectInfoList.json',
        },
        


        login: {
            loginOut: apiDomain + '/user/auth/logout.do',
        },
        getUserInfo: apiDomain + '/system/member/getLoginUser.json',
        selectBoxinfo: {
            //권한 리스트 조회
            authList: apiDomain + '/common/util/code/combobox.json?codegroup=authCode',
            //권한 리스트 조회
            appAuthList: apiDomain + '/common/util/code/combobox.json?codegroup=appAuthCode',
            // 리스트 조회
            memberList: apiDomain + '/common/util/code/combobox.json?codegroup=commonCode&codeId=TL_LC_CD',
        },
    },

}